<template>
  <div
    :id="id"
    ref="searchPageContainer"
    class="searchPageContainer"
    :class="[switchView.viewTypeClass, { hiddenReset: !filters.showReset }]"
    v-if="!lazyTable"
  >
    <adv-setup :config="setupConfig">
      <adv-subHeader v-bind="subheaderProps" v-if="headerReady" @radioChange="TBL_radioChange" @clickButton="TBL_clickButton" />
      <adv-list
        v-if="prepareParams"
        class="advListWrapper"
        :class="hideColumnsProps.columnConfigClass"
        :key="switchView.blockKey"
        v-bind="listData"
        :viewType="switchView.latestSelected"
        :res-break-view="switchView.resBreakView"
        @click="clickList"
        @radioChange="TBL_radioChange"
      />
    </adv-setup>
  </div>
</template>

<script>
import { advList } from '§/components/list';
import { advSubHeader } from '§/components/subHeader';
import { print } from '../../mixins/print';
import { genericEvent, apiMixin } from '§/mixin/commonMixins.js';
import { LabelApi } from '@/epersonam/mixins/labels.js';
import { hideColumnsMixin, switchViewMixin, subHeaderBlockMixin, filterRecapMixin } from '§/mixin/subHeaderMixin.js';
import { tableMixin, contextMixin, filtersMixin } from '§/mixin/table.js';
import { setupConfigMix } from '@/epersonam/mixins/setupConfig.js';

export default {
  name: 'cp2ValDomesticsPrices',
  components: { advList, advSubHeader },
  mixins: [
    print,
    tableMixin,
    contextMixin,
    apiMixin,
    filtersMixin,
    LabelApi,
    hideColumnsMixin,
    switchViewMixin,
    subHeaderBlockMixin,
    filterRecapMixin,
    genericEvent,
    setupConfigMix,
  ],
  props: {
    headerProps: {
      type: Object,
      required: true,
    },
    tableRef: {
      type: String,
    },
    listProps: {
      type: Object,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  async beforeMount() {
    if (!this.lazyTable) {
      this.TBL_setup();
    } else {
      this.TBL_waiting();
    }
  },
  methods: {
    actionButton(response) {
      switch (response.event) {
        case 'printCp2ValDomesticCsv':
          this.print_csv(response);
          break;
        default:
          break;
      }
    },
    print_csv(response) {
      const all_filters = this.FTR_manipulateFilters();
      this.printRequest(
        { ...response.data, current_bu: this.currentBu, current_units: this.currentUnits, ...all_filters },
        'Csv::Cp2ValDomesticsWorker',
      );
    },
    reloadTable() {
      this.FTR_updateList();
    },
    clickList(response) {
      this.edit(response);
      this.TBL_delete(response);
    },
  },
};
</script>
